import type { SVGProps } from 'react'
const LineShareAndroid = (props: SVGProps<SVGSVGElement>) => {
	const width = props.width ?? 24
	const height = props.height ?? 24

	return (
		<svg
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			fill="none"
			{...props}
		>
			<path
				fill="currentColor"
				d="M16.75 15.5c-.92 0-1.75.385-2.345 1.005l-6.05-3.55a3.18 3.18 0 0 0 0-1.905l6.05-3.55a3.24 3.24 0 0 0 2.345 1.005c1.79 0 3.25-1.46 3.25-3.25s-1.46-3.25-3.25-3.25-3.25 1.46-3.25 3.25c0 .33.05.655.145.955l-6.05 3.55A3.23 3.23 0 0 0 5.25 8.755c-1.79 0-3.25 1.46-3.25 3.25s1.46 3.25 3.25 3.25c.92 0 1.75-.385 2.345-1.005l6.05 3.55c-.095.3-.145.62-.145.95 0 1.79 1.46 3.25 3.25 3.25S20 20.54 20 18.75s-1.46-3.25-3.25-3.25m0-12c.965 0 1.75.785 1.75 1.75S17.715 7 16.75 7 15 6.215 15 5.25s.785-1.75 1.75-1.75M5.25 13.75c-.965 0-1.75-.785-1.75-1.75s.785-1.75 1.75-1.75S7 11.035 7 12s-.785 1.75-1.75 1.75m11.5 6.75c-.965 0-1.75-.785-1.75-1.75S15.785 17 16.75 17s1.75.785 1.75 1.75-.785 1.75-1.75 1.75"
			/>
		</svg>
	)
}
export { LineShareAndroid }
